import type { RootState } from '@src/core/store';
import { TariffGroupAttributeTypeEnum } from '@src/core/buyerApiClient/api';

export const productIncludesLanguageSlot = (productId: string, state: RootState): boolean => {
  const attributes = state.product.tariffGroupAttributes[productId] ?? [];

  return attributes.some(
    (attribute) => !attribute.deletedAt && attribute.type === TariffGroupAttributeTypeEnum.Language,
  );
};
